import { render, staticRenderFns } from "./Set_basisbeifen.vue?vue&type=template&id=ee16ade2"
import script from "./Set_basisbeifen.vue?vue&type=script&lang=js"
export * from "./Set_basisbeifen.vue?vue&type=script&lang=js"
import style0 from "./Set_basisbeifen.vue?vue&type=style&index=0&id=ee16ade2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports